const toggleModal = (target) => {
  $(target).toggleClass('active');
};

$(document).on('click', '[data-modal]', function () {
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');
  toggleModal(unique ? '#modal--' + target + unique : '#modal--' + target);
  $('html, body').css('overflow', 'hidden');
  if (!target.length) return;
});

$('.modal__close').on('click', function () {
  const modal = $(this).parent().parent();
  $('html, body').css('overflow', '');
  toggleModal(modal);
});

$(document).keydown(function (e) {
  if (e.keyCode == 27 && $('.modal.active').length) {
    $('html, body').css('overflow', '');
    toggleModal('.active');
  }
});

var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) {
    document.body.classList.add('is-safari');
}
